import * as React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Badge } from "components/bootstrap";
import { OverlayTrigger } from "components/common";
const STATUS_PRESENTATION = {
  ready: { labelKey: "status_cell.labels.ready", icon: "check_circle", color: "success" },
  not_ready: { labelKey: "status_cell.labels.not_ready", icon: "cancel", color: "danger" },
  missing_credentials: { labelKey: "status_cell.labels.missing_credentials", icon: "key", color: "warning" },
  invalid_credentials: { labelKey: "status_cell.labels.invalid_credentials", icon: "key_off", color: "warning" },
  unknown: { labelKey: "status_cell.labels.unknown", icon: "hourglass_top", color: "primary" }
};
const readProvenLine = (readProven) => {
  if (readProven === true) {
    return i18n.t("status_cell.read_proven", { ns: "enterprise_data_tiering" });
  }
  if (readProven === false) {
    return i18n.t("status_cell.read_not_proven", { ns: "enterprise_data_tiering" });
  }
  return null;
};
const StatusCell = ({ repository }) => {
  var _a;
  const { t } = useTranslation("enterprise_data_tiering");
  const presentation = (_a = STATUS_PRESENTATION[repository.status]) != null ? _a : STATUS_PRESENTATION.unknown;
  const presentationLabel = t(presentation.labelKey);
  const { details, credential_details } = repository;
  const readProven = readProvenLine(repository.read_proven);
  const hasDetails = !!(details || credential_details || readProven);
  const statusLabel = /* @__PURE__ */ React.createElement(
    Badge,
    {
      color: presentation.color,
      variant: "light",
      leftIcon: presentation.icon,
      title: presentationLabel,
      "aria-label": presentationLabel
    },
    presentationLabel
  );
  if (!hasDetails) {
    return statusLabel;
  }
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: ["hover", "focus"],
      placement: "bottom",
      title: t("status_cell.status_details"),
      width: 350,
      overlay: /* @__PURE__ */ React.createElement(React.Fragment, null, details && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("status_cell.verification")), " ", details), credential_details && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("status_cell.credentials")), " ", credential_details), readProven && /* @__PURE__ */ React.createElement("p", null, readProven))
    },
    statusLabel
  );
};
export default StatusCell;
